export const isIphone = /(iPhone|iPod)/g.test(window.navigator.userAgent);
